<template>
    <div class="chapter backgroundImage">
        <template v-if="list.length > 0">
            <div class="chapterList" v-for="item, index in list" :key="index" @click="openDeatilFn(item)">
                <p>
                    <span style=" font-weight: bold;">{{ item.unitName || item.name }}</span>
                    <i class="iconfont" style="font-size: 12px;padding-left: 4px;">&#xe61b;</i>
                </p>
                <span><i class="iconfont"
                        style="color: #fff;box-shadow: 0px 3px 7px 0px rgba(0,0,0,0.08);padding: 0;border-radius: 50%;">&#xe626;</i></span>
            </div>
        </template>

        <template v-else>
            <a-empty description="暂无章节" />
        </template>
    </div>
</template>

<script>
import { getAction } from '@/api/manage'
export default {
    name: 'chapter',
    components: {},
    data() {
        return {
            list: [],
        }
    },
    watch:{
        $route(){
            this.init(this.$route.query.id)
        }
    },
    created() {
        this.init(this.$route.query.id)
    },
    mounted() { document.title = this.$route.query.name + '-章节选择' },
    methods: {
        init(id) {
            if (this.$route.query.type == 'DT') {
                getAction(`/sys/category/childListByCode?code=${this.$route.query.code}`).then(res => {
                    if (res.success) {
                        this.list = res.result
                    }
                })
            } else {
                getAction('/teaching/teachingCourseUnit/showCourseUnit', { courseId: id }).then(res => {
                    if (res.code == 200) {
                        this.list = res.result
                    }
                })
            }
        },
        openDeatilFn(row) {
            console.log(row, '章节信息')
            if(this.$route.query.type == 'DT'){
                if(row.hasChild == '1'){
                    this.$router.push({path:'/course/chapter',query:{name:row.name, id:row.id,code:row.code,type:'DT',}})
                }else{
                    this.$router.push({path:'/course/practiceWorkbook',query:{id:row.id,name:row.name}})
                }
            }else{
                this.$router.push({ path: 'videoStudy', query: { id: row.id, name: row.unitName } })
            }
        }
    }
}
</script>

<style lang='scss' scoped>
.chapter {
    width: 100%;
    padding: 20px 17px;
    min-height: calc(100vh - 50px);
    background-image: url('../../assets/image/ZJ_background.png');
    max-width: 1200px;
    margin: 0 auto;

    .chapterList {
        width: 100%;
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: rgba(244, 244, 244, 0.863);
        border: 0px solid;
        border-image: linear-gradient(0deg, #000000, #FFFFFF) 10 10;
        box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.08);
        color: #6E6D6D;
        font-size: 18px;
        border-radius: 5px;
        margin: 16px 0;
        padding: 0 16px;
        cursor: pointer;
    }

    .chapterList:hover {
        background: #F75250;
        color: #fff;
    }
}
</style>
